<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="families"
      class="elevation-10 pa-10"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t("family.title") }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            :label="$t('common.search')"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer />
          <v-btn
            v-if="userStore.isWriter()"
            color="primary"
            dark
            class="mb-2 d-none d-sm-flex"
            @click="addItem()"
          >
            {{ $t("family.button.add") }}
            <v-icon right dark> mdi-plus-circle</v-icon>
          </v-btn>
          <v-btn
            v-if="userStore.isWriter()"
            color="primary"
            dark
            class="d-flex d-sm-none"
            @click="addItem()"
          >
            <v-icon dark> mdi-plus-circle</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mx-2" @click="showItem(item)"> mdi-eye</v-icon>
        <v-icon
          v-if="userStore.isWriter()"
          small
          class="mx-2"
          @click="editItem(item)"
        >
          mdi-pencil</v-icon
        >
        <v-icon
          v-if="userStore.isWriter()"
          small
          class="mx-2"
          @click="deleteItem(item)"
        >
          mdi-delete</v-icon
        >
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import router from "@/router";
import { useFamilyStore } from "@/store/familyStore";
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useUserStore } from "@/store/userStore";

export default {
  data: function () {
    return {
      store: useFamilyStore(),
      userStore: useUserStore(),
      search: ref(""),
      families: null,
      headers: [
        { text: this.$t("family.list.header.id"), value: "id" },
        {
          text: this.$t("family.list.header.name"),
          value: "name",
        },
        {
          text: this.$t("family.list.header.action"),
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  beforeMount() {
    this.families = storeToRefs(this.store).families;
    this.store.getFamilies();
  },
  props: {
    title: String,
  },
  methods: {
    useUserStore,
    addItem() {
      this.store.$reset();
      router.push({ path: "/family/add" });
    },

    showItem(item) {
      this.store.$reset();
      router.push(`family/${item.id}`);
    },

    editItem(item) {
      this.store.$reset();
      router.push(`family/edit/${item.id}`);
    },

    deleteItem(deleteItem) {
      if (confirm(this.$t("family.delete.confirm"))) {
        this.store.deleteFamily(deleteItem.id);
      }
    },
  },
};
</script>
